/** @format */

import { createSlice } from '@reduxjs/toolkit'

// 用户类型定义
export interface User {
  id: number
  code: string
  name: string
  cname: string
  email: string
  phone: string
  status: number
  is_super: boolean
  created_at: string
  updated_at: string
}

// 初始状态
const initialState: User[] = []

// 创建userSlice
export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // 重置用户列表到初始状态
    getUsers: () => []
  }
})

// 导出actions
export const { getUsers } = userSlice.actions

// 导出reducer
export default userSlice.reducer
